
import React from "react";
import { Popup } from "@progress/kendo-react-popup";
import { Icon } from "@iconify/react";
import "./popupmenu.scss";

// interface to declare all our prop types
interface Props {
  children: React.ReactNode;
}

const PopupMenu: React.FC<Props> = ({
  children,
  ...rest
}) => {
  
  const anchor = React.useRef(null);
  const [show, setShow] = React.useState(false);
  React.useEffect(() => {
    setShow(false);
  }, []);

  const onClick = () => {
    setShow(!show);
  };
  
  return (

    <div className="popupmenu"> 
        <button
        className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base"
        onClick={onClick}
        ref={anchor}
      >
      <Icon icon="entypo:dots-three-vertical" />
      </button>
      <Popup anchor={anchor.current} show={show} popupClass={"popup-menu-content"}>
        {children}
      </Popup>
    </div>
  );
};

export default PopupMenu;
